import { useMemo } from 'react';
import { sectionPermissions } from '@qronstat/shared';
import { StaticScreenProvider } from '../screens/ScreenContext';
import type { ScreenDef } from '../screens/types';
import type { ScreenState } from '../state/search';
import { WidgetRenderer } from '../screens/WidgetRenderer';
import type { ReportDefinition } from './types';
import { reportWidget } from './widget';
import { useApp } from '../app/context';
import { objectTypeOfLabel } from '../model/objects';

export { reportWidget } from './widget';

export function stateFromReport(def: ReportDefinition): ScreenState {
  return {
    period: def.period,
    compare: def.compare,
    compareRange: def.compare === 'custom' ? (def.compareRange ?? null) : null,
    filters: def.filters,
    timeMode: def.timeMode,
    realOnly: def.realOnly,
    granularity: def.granularity,
  };
}

export function ReportView({
  definition,
  title,
  id,
}: {
  definition: ReportDefinition;
  title: string;
  id: string;
}) {
  const { meta } = useApp();
  const widget = useMemo(
    () => reportWidget(definition, title, objectTypeOfLabel(meta)),
    [definition, title, meta],
  );
  const screen = useMemo<ScreenDef>(
    () => ({
      id: `report.${id}`,
      title: 'reports.preview',
      titleText: title,
      permission: sectionPermissions.reports,
      quickFilters: [],
      defaultPeriod: definition.period,
      widgets: widget ? [widget] : [],
    }),
    [id, title, definition.period, widget],
  );
  const state = useMemo(() => stateFromReport(definition), [definition]);
  if (!widget) return null;
  return (
    <StaticScreenProvider screen={screen} state={state}>
      <WidgetRenderer def={widget} />
    </StaticScreenProvider>
  );
}
